import { createSelector } from 'reselect';
import { getLanguage, getStateSlice } from './selectors';

function translate(language, productionCode) {
  const productionCodeForLanguage = productionCode.get('info').get(language);
  const code = productionCode.get('code');
  if (!productionCodeForLanguage) {
    throw new Error(
      `No translations available for production code ${code} with language ${language}`
    );
  }
  return {
    code,
    name: productionCodeForLanguage.get('name'),
    slug: productionCodeForLanguage.get('slug')
  };
}

const getProductionMap = state => getStateSlice(state).get('production');
const getMarketProductionMap = state =>
  getStateSlice(state).get('marketProduction');

export const getProductions = createSelector(
  getProductionMap,
  productionMap => productionMap.toList()
);

export const getMarketProductions = createSelector(
  getMarketProductionMap,
  productionMap => productionMap.toList()
);

export const getProductionsTranslated = createSelector(
  getLanguage,
  getProductions,
  (language, productions) => {
    return productions.map(production => translate(language, production));
  }
);

export const getProductionByCodeTranslated = code => {
  return createSelector(
    getLanguage,
    getProductionMap,
    (language, productionMap) => {
      if (!code) {
        return null;
      }
      const entryWithCode = productionMap.get(code);
      return translate(language, entryWithCode);
    }
  );
};
